const apiRoutes = {
  GET_RACES: '/api/getRaces',
  JOIN_TO_RACE: '/api/joinToRace',
  GET_RACES_LEADERBOARD: '/api/getRaceLeaderBoard',
  GET_CMS_RESPONSE: '/api/race-widgets-content?populate=*',
  GET_RACE_MISSION_TEMPLATES: '/api/getRaceMissionTemplates',
};

export default apiRoutes;
